import { defineComponent as _defineComponent } from 'vue'
import type { EditorsPickModuleFragment } from '@/features/onboarded-home/types';
import type { GenericTitleList } from '@/@types/graphql-types';

import FadeTransition from '@/components/transitions/FadeTransition.vue';
import HiddenHorizontalScrollbar from '@/components/HiddenHorizontalScrollbar.vue';
import PosterGraphql from '@/components/poster/PosterGraphql.vue';
import AuthorBox from '@/features/editorial/components/AuthorBox.vue';
import BasicButton from '@/ui-components/BasicButton.vue';
import { jwCheckIcon } from '@/plugins/global-fontawesome';
import { faBookmark } from '@fortawesome/free-solid-svg-icons';

import { toggleFollowList } from '@/components/watchlist/lists-helper';
import { ProfileType } from '@/@types/graphql-types';
import { SnowplowTitleContextGraphql } from '@/helpers/tracking/providers';

import { useProvideClickoutPlacement } from '@/helpers/composables/useProvideClickoutPlacement';
import { useHomeModuleTracking } from '@/features/onboarded-home/tracking';
import { useUserStore } from '@/helpers/composables/useStores';

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'EditorsPickModule',
  props: {
    moduleData: null,
    globalPosition: null,
    localPosition: null
  },
  setup(__props: any) {

const props = __props as {
	moduleData: EditorsPickModuleFragment;
	globalPosition: number;
	localPosition?: number;
};



const { isLoggedIn } = useUserStore();
useProvideClickoutPlacement('editorial_pick');

/* TRACKING */
const { moduleContext, moduleObserveVisibility, trackHomeModule } = useHomeModuleTracking({
	moduleData: () => props.moduleData,
	globalPosition: () => props.globalPosition,
	localPosition: () => props.localPosition,
	objectId: () => props.moduleData.article.id,
});

function getTitleContext(title: EditorsPickModuleFragment['titles'][number]) {
	return SnowplowTitleContextGraphql.fromTitle(title);
}

/* EDITORIAL */
const author = computed(() => props.moduleData.article.author);
const articleContent = computed(() => props.moduleData.article.content);

const articleHeadline = computed(
	() => articleContent.value?.highlightTitle ?? props.moduleData.article.content.title?.replace(/<[^>]*>/g, '') ?? ''
);

/* LIST */
const linkedObjectContent = computed(() => props.moduleData.article?.linkedObjects?.[0]?.node as GenericTitleList);

const isListFollowed = computed(() => !!linkedObjectContent.value?.followedlistEntry?.createdAt);

function handleFollowList() {
	toggleFollowList(
		{
			listId: linkedObjectContent.value?.id,
			isFollowed: isListFollowed.value,
			listName: articleHeadline.value,
		},
		[moduleContext.value]
	);
}

return { __sfc: true,props, isLoggedIn, moduleContext, moduleObserveVisibility, trackHomeModule, getTitleContext, author, articleContent, articleHeadline, linkedObjectContent, isListFollowed, handleFollowList, FadeTransition, HiddenHorizontalScrollbar, PosterGraphql, AuthorBox, BasicButton, jwCheckIcon, faBookmark, ProfileType }
}

})